import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    快速导航: [
      { label: '首页', to: '/' },
      { label: '电影', to: '/category/movie' },
      { label: '电视剧', to: '/category/tv-series' },
      { label: '综艺', to: '/category/variety' },
      { label: '动漫', to: '/category/anime' },
    ],
    关于我们: [
      { label: '品牌介绍', to: '/about' },
      { label: '用户口碑', to: '/about#reputation' },
      { label: '联系方式', to: '/about#contact' },
      { label: '常见问题', to: '/about#faq' },
    ],
    热门推荐: [
      { label: '繁花', to: '/article/m4' },
      { label: '狂飙', to: '/article/m7' },
      { label: '庆余年第二季', to: '/article/m5' },
      { label: '流浪地球2', to: '/article/m2' },
      { label: '三体', to: '/article/m9' },
    ],
  };

  return (
    <footer className="bg-background-950 border-t border-white/5">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="col-span-2 md:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-950">
                  <i className="ri-movie-2-line text-lg"></i>
                </div>
                <span className="text-lg font-semibold text-white whitespace-nowrap">
                  天美麻花星空
                </span>
              </Link>
              <p className="text-foreground-500 text-sm leading-relaxed mb-4">
                高清流畅、免费无忧的在线影视平台，汇聚海量电影、电视剧、综艺、动漫和纪录片资源。
              </p>
            </div>

            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h4 className="text-white text-sm font-semibold mb-4">{title}</h4>
                <ul className="flex flex-col gap-2.5">
                  {links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.to}
                        className="text-foreground-500 hover:text-primary-400 text-sm transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-600 text-xs">
              &copy; {currentYear} 天美麻花星空影视. 本站内容仅供学习交流，请于下载后24小时内删除。
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-foreground-500 hover:text-primary-400 text-xs transition-colors">隐私政策</a>
              <a href="#" className="text-foreground-500 hover:text-primary-400 text-xs transition-colors">服务条款</a>
              <a href="#" className="text-foreground-500 hover:text-primary-400 text-xs transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}